import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableInquiryPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableInquiryPage;
